import { render, staticRenderFns } from "./AmountUnitInput.vue?vue&type=template&id=287c62b6&scoped=true"
import script from "./AmountUnitInput.vue?vue&type=script&lang=js"
export * from "./AmountUnitInput.vue?vue&type=script&lang=js"
import style0 from "./AmountUnitInput.vue?vue&type=style&index=0&id=287c62b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287c62b6",
  null
  
)

export default component.exports